import React, {
  //
  useState,
  useContext,
} from "react";
import {
  //
  bearlog,
  BearDiv,
  BearPage,
  BearList,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import Popover from "react-awesome-popover";
import { getEmoji } from "../consts/emojiConst";
import { getBaseNotes } from "../functions/noteFuncs";

export function PageMain({ headerConfig, ...aaaa }) {
  const {
    //
    noteChord,
    isnSound,
    setisnSound,
    reffo,
    playChord,
    playKey,
    shiftpic,
    playMain,
    picho,
  } = useContext(MainContext);

  const { color } = noteChord ? getEmoji(noteChord) : "";

  function Poppop(item, config) {
    const okas = {};
    return (
      <Popover {...okas}>
        {item}
        {/* {BearList(config)} */}
      </Popover>
    );
  }

  // 1instruemnt
  const jase = Poppop({
    item: rednIna(isnSound),
    // config
  });

  // 1key
  function rednIna(ins) {}

  // 1right
  const asdfewr = {
    list: ["inst", "key"],
    dictvar: {
      inst: { textvar: jase },
      key: { textvar: "C" },
    },
    itemConfig: {
      className: "buttonHover",
    },
  };

  //   1header
  const asdwe = {
    logoText: "SongKey",
    // navRight: asdfewr,
    //  logoConfig: { style: { color: "white" } },
    ...headerConfig,
  };

  let goGlasss = color ? color : "home";

  bearlog.lug("___ pagMain ___", { goGlasss });

  aaaa = {
    // headerConfig: asdwe,
    className: goGlasss,
    style: {
      //
      color: "white",
    },
    ...aaaa,
  };

  return BearPage(aaaa);
}
